import "./Results.module.css";
import Navigation from "@/reusable_sections/Header";
import Success from "./sections/Success";
import Perspectives from "./sections/Perspectives";
import Impact from "./sections/Impact";
import Footer from "@/reusable_sections/Footer";
export default function ResultsPage() {
  return <div>
      <Navigation />
      <Success />
      <Perspectives />
      <Impact />
      <Footer />
    </div>;
}